/** Leaf menu keys. Must match [dbo].[Menu].[MenuKey] and CollectX.Common/Helpers/MenuKeys.cs. */
export const MENU_KEYS = {
  Dashboard: 'Dashboard',
  AdminUsers: 'AdminUsers',
  ArchiveAdminUsers: 'ArchiveAdminUsers',
  AppUsers: 'AppUsers',
  ArchiveAppUsers: 'ArchiveAppUsers',
  AnonymousAppUsers: 'AnonymousAppUsers',
  VaultXBinders: 'VaultXBinders',
  /** NFC URLs of VaultX binders (permission only: lives inside the VaultX Binders pages, no sidebar entry). */
  VaultXBinderNfc: 'VaultXBinderNfc',
  Game: 'Game',
  Set: 'Set',
  Cards: 'Cards',
  CardCorrection: 'CardCorrection',
  SupportTickets: 'SupportTickets',
  Notifications: 'Notifications',
  AppVersions: 'AppVersions',
  Settings: 'Settings',
  RoleManagement: 'RoleManagement',
} as const;

/**
 * Route and icon per menu key. Names, hierarchy, order and visibility come from the API;
 * a menu returned by the API without an entry here is not shown in the sidebar.
 * A group without an entry (VaultXBinderManagement) only groups permissions: the sidebar
 * shows its pages as top-level items instead of a submenu.
 */
export const MENU_UI: Record<string, { route?: string; icon: string }> = {
  Dashboard: { route: '/dashboard', icon: 'assets/images/dashboard.svg' },
  AdminUserManagement: { icon: 'assets/images/admin-user.svg' },
  AdminUsers: { route: '/admin-user', icon: 'assets/images/admin-users.svg' },
  ArchiveAdminUsers: { route: '/admin-user/archive-admin-user', icon: 'assets/images/archive-users.svg' },
  AppUserManagement: { icon: 'assets/images/profile-2user.svg' },
  AppUsers: { route: '/app-user', icon: 'assets/images/admin-users.svg' },
  ArchiveAppUsers: { route: '/app-user/archive-app-user', icon: 'assets/images/archive-users.svg' },
  AnonymousAppUsers: { route: '/app-user/anonymous-app-user', icon: 'assets/images/archive-users.svg' },
  VaultXBinders: { route: '/vaultx-binder', icon: 'assets/images/vaultx.svg' },
  CardManagement: { icon: 'assets/images/cards-manage.svg' },
  Game: { route: '/card-management/game-list', icon: 'assets/images/game.svg' },
  Set: { route: '/card-management/sets', icon: 'assets/images/sets.svg' },
  Cards: { route: '/card-management/cards-list', icon: 'assets/images/menu-card.svg' },
  CardCorrection: { route: '/card-management/override-list', icon: 'assets/images/menu-card-2.svg' },
  SupportTickets: { route: '/support-tickets', icon: 'assets/images/support-tickets.svg' },
  Notifications: { route: '/notification', icon: 'assets/images/notifications.svg' },
  AppVersions: { route: '/app-version-management', icon: 'assets/images/setting.svg' },
  Settings: { route: '/setting', icon: 'assets/images/setting.svg' },
  RoleManagement: { route: '/role-management', icon: 'assets/images/setting.svg' },
};
